module.exports = __webpack_public_path__ + "img/logo1.2807da7d.png";